import { BranchService } from 'api/generated';
import { QueryError } from 'features/shared/model';
import { UseQueryOptions, useQuery } from 'react-query';

export const useBranchesQueryKey = 'GetBranches';
export const useBranchesQuery = <TQueryKey extends Array<unknown> = unknown[]>(
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<
      Awaited<ReturnType<typeof BranchService.getBranch>>,
      QueryError,
      Awaited<ReturnType<typeof BranchService.getBranch>>,
      unknown[]
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >
) => useQuery([useBranchesQueryKey, ...(queryKey ?? [])], () => BranchService.getBranch(), options);
